import React, { useState } from 'react';
import MetaWhatsappPhoneNumberSection from '../components/Settings/MetaWhatsappPhoneNumberSection';
import NexiGlobalTemplateSection from '../components/Settings/NexiGlobalTemplateSection';

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">Settings</h1>

      <div className="mb-4 border-b border-gray-200">
        <nav className="flex -mb-px">
          <button
            onClick={() => setActiveTab(0)}
            className={`px-6 py-3 text-sm font-medium ${
              activeTab === 0
                ? 'border-b-2 border-[#075e54] text-[#075e54]'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Meta WhatsApp Phone Numbers
          </button>
          <button
            onClick={() => setActiveTab(1)}
            className={`px-6 py-3 text-sm font-medium ${
              activeTab === 1
                ? 'border-b-2 border-[#075e54] text-[#075e54]'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Global Templates
          </button>
        </nav>
      </div>

      <div className={activeTab === 0 ? 'block' : 'hidden'}>
        <MetaWhatsappPhoneNumberSection />
      </div>

      <div className={activeTab === 1 ? 'block' : 'hidden'}>
        <NexiGlobalTemplateSection />
      </div>
    </div>
  );
};

export default Settings;
